import { useEditor } from '@eastcoal/editor/hooks/useEditor'
import { UPLOAD_IMAGE_COMMAND } from '@eastcoal/editor/plugins/ImagePlugin/commands'
import { WpsImageIcon } from '@eastcoal/icon/WpsImageIcon'

import { IsolatedButton } from '../IsolatedButton'

export const ImageButton = () => {
  const editor = useEditor()

  const handleUploadImage = () => {
    editor.dispatchCommand(UPLOAD_IMAGE_COMMAND, undefined)
  }

  return (
    <IsolatedButton onClick={handleUploadImage}>
      <WpsImageIcon />
      <span>图片</span>
    </IsolatedButton>
  )
}
